import React, { useEffect, useState } from "react";
// import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle, CardSubtitle, Button, Util } from "reactstrap";
import "./Card.scss";
import '../Icons/IconFontawesome';
import Utils from '../Utility';
import { post, get, put } from "../../helpers/api_helper";
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import Modal from './DeleteModal';
import DataTable from 'react-data-table-component';
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from 'react-toastify';
const { io } = require("socket.io-client");

const LeadSingle = (props) => {
  const { user, role, leadId } = props;
  const [data, setData] = useState([]);
  const [lead, setLead] = useState(null);
  const [message, setMessage] = useState("");
  const [isModal, setIsModal] = useState(false);
  const [modalData, setModalData] = useState({ type: "Delete" });
  const [messageEnd, setMessagesEnd] = useState(null);
  const [form, setForm] = useState(null);
  const [socket, setSocket] = useState(null);
  const [timeline, setTimeline] = useState([]);
  const [currentTab, setCurrentTab] = useState('timeline');

  useEffect(() => {
    if (user?.companyId) {
      getLead();
    }
  }, [user, leadId]);

  useEffect(() => {
    const socket = io("http://192.168.0.172:8080/chat", { transports: ["websocket"], upgrade: false });
    socket.on("get", (res) => {
      // console.log('socket on list', res);
      if (res?.statusCode == 200) {
        // console.log(res?.data)
        setData(res?.data);
      }
    });
    socket.on("connect", (socket2) => {
      // console.log(socket.id);
      socket.emit("list", { id: leadId, auth: user?.token });
    });
    setSocket(socket);

    return () => {
      if (socket.readyState === 1) {
        // socket.close();
      }
      // socket.disconnect();
      // setSocket(null);
    }

  }, [lead]);

  const getLead = async () => {
    get("/lead/detail?leadId=" + leadId, { token: user?.token })
      .then(json => {
        // console.log('response from get chat list', json);
        if (json?.statusCode == 200) {
          setLead(json?.data);
          let timeline = json?.data?.timeline;
          setTimeline(timeline);
        }
      })
      .catch(error => {
        console.log('error while getting lead detail', error);
      })
  }

  // const getChat = async () => {
  //   console.log('lead id on get chat', leadId);
  //   socket.on("connect", (socket2) => {
  //     // console.log(socket.id);
  //     socket.emit("list", { id: leadId, auth: user?.token });
  //   });
  // }

  // useEffect(() => {
  //   if (socket) {
  //     socket.on("get", (res) => {
  //       // console.log('socket on list', res);
  //       if (res?.statusCode == 200) {
  //         // console.log(res?.data)
  //         setData(res?.data);
  //       }
  //     });
  //     socket.on("connect", (socket2) => {
  //       // console.log(socket.id);
  //       socket.emit("list", { id: leadId, auth: user?.token });
  //     });
  //   }
  // }, [socket]);

  useEffect(() => {
    if (currentTab == 'chat')
      document.getElementById('messages').scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
  }, [data]);

  const sendMsg = (values) => {
    console.log('emiting msg');
    socket.emit("msg", {
      msg: values?.message,
      from: user?._id,
      leadId: leadId,
      auth: user?.token
    });
    form.reset();
  }

  return (
    <React.Fragment>
      <div className="">
        <div className="d-flex" style={{ justifyContent: 'space-around' }}>
          <div>
            <p style={{ color: 'black', fontWeight: 'bold', fontSize: 12 }}>{lead?.name}</p>
            <div className="d-flex" style={{ alignItems: 'baseline' }}>
              <p style={{ fontSize: 12 }}>Source : </p>
              <p style={{ color: 'black', fontWeight: 'bold', fontSize: 12, marginLeft: 8 }}>{lead?.source}</p>
            </div>
          </div>
          <div>
            <div className="d-flex" style={{ alignItems: 'baseline' }}>
              <p style={{ fontSize: 12 }}>Current Status : </p>
              <div style={{ marginLeft: 8 }}>
                {lead?.status == 'Open' &&
                  <div style={{ border: '2px dashed orange', paddingLeft: 5, paddingRight: 5, borderRadius: 5 }}>
                    <span style={{ fontSize: 12, color: 'orange' }}>{lead?.status}</span>
                  </div>
                }
                {lead?.status == 'Closed' &&
                  <div style={{ border: '2px dashed green', paddingLeft: 5, paddingRight: 5, borderRadius: 5 }}>
                    <span style={{ fontSize: 12, color: 'green' }}>{lead?.status}</span>
                  </div>
                }
                {lead?.status == 'In Process' &&
                  <div style={{ border: '2px dashed blue', paddingLeft: 5, paddingRight: 5, borderRadius: 5 }}>
                    <span style={{ fontSize: 12, color: 'blue' }}>{lead?.status}</span>
                  </div>
                }
                {lead?.status == 'Rejected' &&
                  <div style={{ border: '2px dashed red', paddingLeft: 5, paddingRight: 5, borderRadius: 5 }}>
                    <span style={{ fontSize: 12, color: 'red' }}>{lead?.status}</span>
                  </div>
                }
                {lead?.status == 'Archived' &&
                  <div style={{ border: '2px dashed black', paddingLeft: 5, paddingRight: 5, borderRadius: 5 }}>
                    <span style={{ fontSize: 12, color: 'black' }}>{lead?.status}</span>
                  </div>
                }
              </div>
            </div>
            <div className="d-flex" style={{ alignItems: 'baseline' }}>
              <p style={{ fontSize: 12 }}>Added : </p>
              <p style={{ color: 'black', fontWeight: 'bold', fontSize: 12, marginLeft: 8 }}>{lead?.createdAt}</p>
            </div>
          </div>
          <div>
            <div className="d-flex" style={{ alignItems: 'baseline' }}>
              <p style={{ fontSize: 12 }}>Client Email : </p>
              <p style={{ color: 'black', fontWeight: 'bold', fontSize: 12, marginLeft: 8 }}> {lead?.email}</p>
            </div>
            <div className="d-flex" style={{ alignItems: 'baseline' }}>
              <p style={{ fontSize: 12 }}>Client Mobile : </p>
              <p style={{ color: 'black', fontWeight: 'bold', fontSize: 12, marginLeft: 8 }}> {lead?.mobile}</p>
            </div>
          </div>
          <div>
            <div className="d-flex" style={{ alignItems: 'baseline' }}>
              <p style={{ fontSize: 12 }}>Client Name : </p>
              <p style={{ color: 'black', fontWeight: 'bold', fontSize: 12, marginLeft: 8 }}> {lead?.clientName}</p>
            </div>
            <div className="d-flex" style={{ alignItems: 'baseline' }}>
              <p style={{ fontSize: 12 }}>Location : </p>
              <p style={{ color: 'black', fontWeight: 'bold', fontSize: 12, marginLeft: 8 }}> {lead?.address}</p>
            </div>
          </div>
          <div>
            <img src={'https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/PDF_file_icon.svg/833px-PDF_file_icon.svg.png'} style={{ width: 50, height: 65, cursor: 'pointer' }} />
          </div>
          <div>
          </div>
        </div>

        <div style={{ marginTop: 20 }}>
          {/* Bounding box for the Timeline */}
          <div style={{ borderBottom: '1px solid blue', width: '90%', margin: 'auto' }}>
            <div className="d-flex" style={{}}>
              <span style={{
                fontSize: 20, borderRight: `1px solid ${user?.company?.theme ? user?.company?.theme : Utils.themeColor}`,
                borderLeft: `1px solid ${user?.company?.theme ? user?.company?.theme : Utils.themeColor}`, width: '50%', textAlign: 'center',
                backgroundColor: currentTab == 'timeline' ? user?.company?.theme ? user?.company?.theme : 'white' : 'white', paddingTop: 5, paddingBottom: 5,
                color: currentTab == 'timeline' ? 'white' : 'black', cursor: 'pointer'
              }} onClick={() => setCurrentTab('timeline')}>
                Timeline
              </span>
              <span style={{
                fontSize: 20, borderRight: `1px solid ${user?.company?.theme ? user?.company?.theme : Utils.themeColor}`,
                borderLeft: `1px solid ${user?.company?.theme ? user?.company?.theme : Utils.themeColor}`,
                width: '50%', textAlign: 'center',
                backgroundColor: currentTab == 'chat' ? user?.company?.theme ? user?.company?.theme : 'white' : 'white', paddingTop: 5, paddingBottom: 5,
                color: currentTab == 'chat' ? 'white' : 'black', cursor: 'pointer'
              }} onClick={() => setCurrentTab('chat')}>
                Chat
              </span>
            </div>
          </div>
          {currentTab == 'timeline' &&
            <div style={{ width: '90%' }}>
              {timeline?.map((item) => {
                return (
                  <VerticalTimeline
                    layout="1-column-left"
                    lineColor={user?.company?.theme ? user?.company?.theme : Utils.themeColor}
                  >
                    <VerticalTimelineElement
                      className="vertical-timeline-element--work"
                      contentStyle={{ background: user?.company?.theme ? user?.company?.theme : Utils.themeColor, color: '#fff' }}
                      contentArrowStyle={{ borderRight: user?.company?.theme ? user?.company?.theme : Utils.themeColor }}
                      date={item?.createdAt}
                      iconStyle={{ background: user?.company?.theme ? user?.company?.theme : Utils.themeColor, color: '#fff', textAlignLast: 'center' }}
                      icon={<i className="mdi mdi-calendar-check" style={{ fontSize: 26 }} />}
                      position={'right'}
                    >
                      <p style={{ color: 'white', fontWeight: 'bold', fontSize: 16 }}>{item?.title}</p>
                      <p style={{ fontSize: 12, color: 'white' }}>
                        {item?.desc}
                      </p>
                    </VerticalTimelineElement>
                  </VerticalTimeline>
                )
              })}
              {/* <HorizontalTimeline
              index={currentIndex}
              indexClick={(index) => {
                setPrevIndex(currentIndex);
                setCurrentIndex(index);
              }}
              styles={{ outline: '#dfdfdf', background: '#f8f8f8', foreground: user?.company?.theme ? user?.company?.theme : Utils.themeColor }}
              values={values} /> */}
            </div>
          }
          {currentTab == 'chat' &&
            <>
              <div style={{ height: 500, overflow: 'scroll', marginTop: 30 }}>
                <div id="messages">
                  {data?.length < 1 ?
                    <span style={{ position: 'absolute', top: '50%', left: '45%', fontSize: 12 }} >No Messages!</span>
                    :
                    <div style={{}} ref={(el) => { setMessagesEnd(el) }}>
                      {data?.map((item, index) => {
                        return (
                          <Card key={item?._id}>
                            {item?.from == user?._id ?
                              <div style={{}}>
                                <div style={{ float: 'right' }}>
                                  <div className="my-msg">
                                    <div style={{ textAlign: 'right', margin: 'auto' }}>
                                      <div className="msg-view">
                                        <span className="msg"
                                          style={{ backgroundColor: user?.company?.theme ? user?.company?.theme + '55' : Utils.themeColor }}
                                        > {item?.msg} </span>
                                      </div>
                                      <span className="my-time">{item?.createdAt}</span>
                                    </div>
                                    <div style={{ textAlign: '-webkit-center', margin: 'auto' }}>
                                      <div style={{ border: `1px solid ${user?.company?.theme ? user?.company?.theme : Utils.themeColor}` }} className="img-view">
                                        <img src={'https://res.cloudinary.com/dzyvfuddu/image/upload/v1667977652/hacker_bpmwks.jpg'} className="img" />
                                      </div>
                                      <span className="name">{item?.user[0]?.name}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              :
                              <CardBody>
                                <div className="other-msg">
                                  <div style={{ textAlign: '-webkit-center', margin: 'auto 0' }}>
                                    <div style={{ border: `1px solid ${user?.company?.theme ? user?.company?.theme : Utils.themeColor}` }} className="img-view">
                                      <img src={'https://res.cloudinary.com/dzyvfuddu/image/upload/v1667977652/hacker_bpmwks.jpg'} className="img" />
                                    </div>
                                    <span className="name">{item?.user[0]?.name}</span>
                                  </div>
                                  <div style={{ textAlign: 'left', margin: 'auto 0' }}>
                                    <div className="msg-view">
                                      <span
                                        style={{ backgroundColor: user?.company?.theme ? user?.company?.theme + '77' : Utils.themeColor }}
                                        className="msg"> {item?.msg}</span>
                                    </div>
                                    <span className="time">{item?.createdAt}</span>
                                  </div>
                                </div>
                              </CardBody>
                            }
                          </Card>
                        )
                      })}
                      {/* <div style={{ float: "left", clear: "both" }}
                ref={(el) => { setMessagesEnd(el) }}>
              </div> */}
                    </div>
                  }
                </div>
              </div>
              <div style={{}} >
                <AvForm onValidSubmit={(event, values) => sendMsg(values)} ref={c => (setForm(c))}>
                  <div className="d-flex" style={{ alignItems: 'flex-end' }}>
                    <div style={{ width: '95%' }}>
                      <AvField
                        placeholder={"Enter Message"}
                        value={message}
                        name={"message"}
                        type="textarea"
                        onChange={e => setMessage(e.target.value)}
                        value={message}
                        required
                      />
                    </div>
                    <Button style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, minWidth: '8%', maxHeight: 40, marginLeft: 5, marginRight: 5 }}
                      type={"submit"}
                    >
                      <i className="mdi mdi-send" />
                    </Button>
                  </div>
                </AvForm>
              </div>
            </>
          }
        </div>
      </div>
    </React.Fragment>
  )
}

export default LeadSingle;
